/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseImageFragment, ImageFragment, FullImageFragment} from '@amblique/contentful/app/contentful/fragments/image';

/**
 * Get a single Image by ID (base - scalars only)
 */
export const getBaseImageById = gql`
  ${BaseImageFragment}

  query GetBaseImageById($id: String!, $locale: String!, $preview: Boolean) {
    image(id: $id, locale: $locale, preview: $preview) {
      ...BaseImageFragment
    }
  }
`;

/**
 * Get a single Image by ID (standard - 1 level deep)
 */
export const getImageById = gql`
  ${ImageFragment}

  query GetImageById($id: String!, $locale: String!, $preview: Boolean) {
    image(id: $id, locale: $locale, preview: $preview) {
      ...ImageFragment
    }
  }
`;

/**
 * Get a single Image by ID (full - 2 levels deep)
 */
export const getFullImageById = gql`
  ${FullImageFragment}

  query GetFullImageById($id: String!, $locale: String!, $preview: Boolean) {
    image(id: $id, locale: $locale, preview: $preview) {
      ...FullImageFragment
    }
  }
`;

/**
 * Get all Image entries with pagination (base - scalars only)
 */
export const getBaseImages = gql`
  ${BaseImageFragment}

  query GetBaseImages(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ImageOrder]
    $where: ImageFilter
    $preview: Boolean
  ) {
    imageCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseImageFragment
      }
    }
  }
`;

/**
 * Get all Image entries with pagination (standard - 1 level deep)
 */
export const getImages = gql`
  ${ImageFragment}

  query GetImages(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ImageOrder]
    $where: ImageFilter
    $preview: Boolean
  ) {
    imageCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...ImageFragment
      }
    }
  }
`;

/**
 * Get all Image entries with pagination (full - 2 levels deep)
 */
export const getFullImages = gql`
  ${FullImageFragment}

  query GetFullImages(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ImageOrder]
    $where: ImageFilter
    $preview: Boolean
  ) {
    imageCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullImageFragment
      }
    }
  }
`;
